const defaults = {
  maxRetries: 3 // Default number of retries for fetching results
};
const results = (
  state = {
    isFetching: false,
    isFetchingAlternative: false,
    result: [],
    resultAlternative: [],
    header: [],
    aggregations: [],
    searchExecuted: false,
    searchAlternativeExecuted: false,
    count: 0,
    countAlternative: 0,
    maxRetries: defaults.maxRetries,
  }, action) => {
  switch (action.type) {
    case 'REQUEST_RESULTS':
      return Object.assign({}, state, {
        isFetching: true
      });

    case 'REQUEST_ALTERNATIVE_RESULTS':
      return Object.assign({}, state, {
        isFetchingAlternative: true,
      });

    case 'CLEAR_RESULTS':
      return Object.assign({}, state, {
        result: [],
        count: false,
        aggregations: [],
        searchExecuted: false,
      });

    case 'CLEAR_RESULTS_ALTERNATIVE':
      return Object.assign({}, state, {
        searchAlternativeExecuted: false,
        resultAlternative: '',
        countAlternative: false,
      });

    case 'RESET_FETCHING':
      return Object.assign({}, state, {
        isFetching: false,
      });

    case 'RESET_FETCHING_ALTERNATIVE':
      return Object.assign({}, state, {
        isFetchingAlternative: false,
      });

    case 'RECEIVE_RESULTS':
      return Object.assign({}, state, {
        isFetching: false,
        result: action.json.data,
        attributes: action.json.meta.productFinderColumns,
        productFinderFilterTypes: action.json.meta.productFinderFilterTypes,
        aggregations: action.json.meta.aggregations,
        count: action.json.meta.count,
        searchExecuted: !!action.withResults,
      });

    case 'RECEIVE_ALTERNATIVE_RESULTS':
      return Object.assign({}, state, {
        isFetchingAlternative: false,
        resultAlternative: action.json.content,
        countAlternative: action.json.count,
        searchAlternativeExecuted: !!action.withResults,
      });
    case 'RECEIVE_ALTERNATIVE_RESULTS_COUNT':
      return Object.assign({}, state, {
        isFetchingAlternative: false,
        resultAlternative: '',
        countAlternative: action.count,
        searchAlternativeExecuted: !!action.withResults,
      });

    case 'DELETE_PATH':
      const newAggregations = {...state.aggregations};

      if (action.filterKey === 'group') {
        delete newAggregations.path;
      } else if (action.filterKey === 'category') {
        delete newAggregations.path?.category;
        delete newAggregations.path?.lineup;
        delete newAggregations.path?.series;
      } else if (action.filterKey === 'lineup') {
        delete newAggregations.path?.lineup;
        delete newAggregations.path?.series;
      } else if (action.filterKey === 'series') {
        delete newAggregations.path?.series;
      }

      return Object.assign({}, state, {
        aggregations: newAggregations,
      });

    case 'DECREASE_MAX_RETRIES':
      return Object.assign({}, state, {
        maxRetries: --state.maxRetries
      });

     case 'RESET_MAX_RETRIES':
      return Object.assign({}, state, {
        maxRetries: defaults.maxRetries
      }); 
    default:
      return {...state}
  }
};

export default results
